<template>
  <div class="flex px-4 py-3 space-x-2 border rounded-md">
    <FontAwesomeIcon v-if="icon" :icon="icon" class="mt-1" />
    <div class="flex-auto font-medium"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'UtilInfo',
  props: {
    icon: { type: Object }
  }
}
</script>
